import React from 'react';
import './PromotionStateExpired.css';
import { useTranslations } from '../../../../../../shared/src/hooks/use-translations.hook';

export const PromotionStateExpired = () => {
    const { t } = useTranslations();

    return (
        <div className="asg-promotion-fold-thumbnail__state-expired">{t('promotionExpired')}</div>
    );
};
